import Vue from 'vue';
import VueRouter from 'vue-router';
import PostWall from '@/views/PostWall.vue';
import AddNewPost from '@/views/AddNewPost.vue';
import Login from '@/views/Login.vue';
import NoticeMessage from '@/views/NoticeMessage.vue';
import SharePost from '@/views/SharePost.vue';
import OnePost from '@/views/OnePost.vue';
import Album from '@/views/Album.vue';
import Setting from '@/views/Setting.vue';
import EditPost from '@/views/EditPost.vue';
import Home from '@/views/Home.vue';

// 解除重複路由問題
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(VueRouter);

const routes = [
  // 首頁
  {
    path: '/home/:token?',
    name: 'Home',
    component: Home
  },
  // 貼文牆
  {
    path: '/postWall/:token?',
    name: 'PostWall',
    component: PostWall
  },
  // 我自己的貼文牆
  {
    path: '/myPost/:token?',
    name: 'MyPost',
    component: PostWall
  },
  // 某位朋友的貼文牆
  {
    path: '/friendPost/:fid/:token?',
    name: 'FriendPost',
    component: PostWall
  },
  // 新增貼文
  { path: '/addNewPost', name: 'AddNewPost', component: AddNewPost },
  // 分享貼文
  { path: '/sharePost/:postId', name: 'SharePost', component: SharePost },
  // 編輯貼文
  { path: '/editPost', name: 'EditPost', component: EditPost },
  // 外部分享友圈(從消息、活動、買迷等服務過來)
  { path: '/shareToGawbue/:apName/:targetId/token/:token', name: 'ShareOtherPost', component: SharePost },
  // 登入導轉(已廢棄)
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  // 鈴鐺通知頁
  {
    path: '/noticeMessage/:token?',
    name: 'NoticeMessage',
    component: NoticeMessage
  },
  // 點擊某則通知後顯示的單一貼文頁
  {
    path: '/onePost/:postId/:notificationId',
    name: 'OnePost',
    component: OnePost
  },
  // 相簿
  {
    path: '/album/:token?',
    name: 'Album',
    component: Album
  },
  // 設定
  {
    path: '/setting/:token?',
    name: 'Setting',
    component: Setting
  },
  // 所有不符合格式的都導轉到貼文牆頁
  {
    path: '*',
    redirect: { name: 'Home' }
  }
];

const router = new VueRouter({
  routes
});

export default router;
